export default __webpack_public_path__ + "static/media/back-button-black.9d104d8c.svg";